import React, { useState, useEffect } from "react";
import Loading from "../components/Loading";
import { FaEye, FaTimes, FaUser } from "react-icons/fa";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { getTicketToken } from "../slice/ticketToken";

const Ticket = () => {
  const dispatch = useDispatch();
  const { user, url } = useSelector((state) => state.user);
  const { ticket_token } = useSelector((state) => state.ticket_token);
  const [tickets, setTickets] = useState([]);
  const [loading, setloading] = useState(true);
  //
  const getTickets = async () => {
    try {
      const res = await axios.get(
        `${url}/proxy?url=https://desk.zoho.in/api/v1/tickets/search?limit=100&email=${user.Email}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${ticket_token}`,
          },
        }
      );
      if (res.status === 200) {
        const data = await res.data.data;
        data.forEach((obj) => {
          for (const key in obj) {
            if (obj[key] === null) {
              obj[key] = "";
            }
          }
        });
        data.forEach((item) => {
          if (item.createdTime !== null || item.createdTime !== "-") {
            let date = item.createdTime
              .split("T")[0]
              .split("-")
              .reverse()
              .join("-");
            let time = item.createdTime.split("T")[1].split(".")[0];
            item.createdTime = `${date} at ${time}`;
          }
        });
        data.forEach((item) => {
          if (item.status === "Closed" || item.status === "closed") {
            let date = item.closedTime
              .split("T")[0]
              .split("-")
              .reverse()
              .join("-");
            let time = item.closedTime.split("T")[1].split(".")[0];
            item.closedTime = `${date} at ${time}`;
          }
        });
        setTickets(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    dispatch(getTicketToken());
  }, []);
  useEffect(() => {
    if (ticket_token !== null) {
      getTickets();
    }
  }, [ticket_token]);
  //
  const [modalVisible, setModalVisible] = useState(false);
  const [details, setDetails] = useState([]);
  const openModal = async (item) => {
    try {
      dispatch(getTicketToken());
      const res = await axios.get(
        `${url}/proxy?url=https://desk.zoho.in/api/v1/tickets/${item.id}/threads`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${ticket_token}`,
          },
        }
      );
      if (res.status === 200) {
        const emails = res.data.data;
        emails.forEach((item) => {
          const fromEmail = item.fromEmailAddress?.toLowerCase() || "";
          if (
            fromEmail.includes("advocate") ||
            fromEmail.includes("customer")
          ) {
            item.ourMessage = true;
          } else {
            item.ourMessage = false;
          }
        });
        emails.forEach((item) => {
          const date = new Date(item.createdTime);
          const options = {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          };

          item.createdTime = date.toLocaleString("en-US", options);
        });

        setDetails(res.data.data);
        setModalVisible(true);
      } else {
        dispatch(getTicketToken());
      }
    } catch (error) {
      console.log(error);
    }
  };
  const closeModal = () => {
    setDetails([]);
    setModalVisible(false);
  };
  return (
    <>
      <div className="journal container p-2">
        <div className="py-4">
          <h2 className="text-center">Tickets</h2>
          {loading ? (
            <Loading />
          ) : tickets.length !== 0 ? (
            <>
              <div className="table-responsive mt-4">
                <table className="table table-bordered table-hover table-striped ticket-table">
                  <thead>
                    <tr>
                      <th className="gradient-bg">Ticket number</th>
                      <th className="gradient-bg">Subject</th>
                      <th>View message</th>
                      <th className="gradient-bg">Department</th>
                      <th className="gradient-bg">Status</th>
                      <th className="gradient-bg">Created time</th>
                      <th className="gradient-bg">Closed time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tickets.map((item, index) => {
                      if (
                        item.department.name ===
                          "Customer service department" ||
                        item.department.name === "Legal Team"
                      )
                        return (
                          <tr
                            key={index}
                            style={{
                              borderLeft: `5px solid ${
                                item.status === "Open" || item.status === "open"
                                  ? "danger"
                                  : "success"
                              }`,
                            }}
                          >
                            <td>
                              <span>#{item.ticketNumber}</span>
                            </td>
                            <td>
                              <span className="table-clamp">
                                {item.subject}
                              </span>
                            </td>
                            <td>
                              <button
                                className="button"
                                onClick={() => openModal(item)}
                              >
                                View Message
                                <FaEye className="ms-2" />
                              </button>
                            </td>
                            <td>
                              <span className="table-clamp">
                                {item.department.name}
                              </span>
                            </td>
                            <td>
                              <span className="table-clamp">{item.status}</span>
                            </td>
                            <td>
                              <span className="table-clamp">
                                {item.createdTime}
                              </span>
                            </td>
                            <td>
                              <span className="table-clamp">
                                {item.closedTime}
                              </span>
                            </td>
                          </tr>
                        );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <p className="text-center my-4">No data found</p>
          )}
        </div>
      </div>

      {/* modal */}
      <div className={`custom-modal-container ${modalVisible ? "active" : ""}`}>
        <div className="custom-modal-background" onClick={closeModal}></div>
        <div className="custom-modal-box ticket-modal-box">
          <div
            className="header p-2"
            style={{ borderBottom: "2px solid #000" }}
          >
            <p className="fw-bold text-capitalize">Ticket message</p>
            <div style={{ cursor: "pointer" }} onClick={closeModal}>
              <FaTimes />
            </div>
          </div>
          <div className="body p-2">
            {details.length !== 0 ? (
              <>
                {details.map((item, index) => {
                  return (
                    <div
                      className={`ticket-chat-box ${
                        item.ourMessage === true ? "our-message" : ""
                      } ${index === details.length - 1 ? "" : "mb-4"}`}
                      key={index}
                    >
                      <div className="ticket-chat-flex">
                        <div>
                          <div className="ticket-chat-user">
                            <FaUser />
                          </div>
                          <small className="text-wrap">
                            {item.ourMessage === true
                              ? "SingleDebt"
                              : user.First_Name}
                          </small>
                        </div>
                        <div className="ticket-chat-message">
                          <p>{item.summary}</p>
                        </div>
                      </div>
                      <div
                        className={
                          item.ourMessage === true ? "text-end" : "text-start"
                        }
                      >
                        <small>{item.createdTime.toLocaleString()}</small>
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Ticket;
